<template>
  <section class="mt-3" id="chart">
    <div v-for="(chart, i) in charts" :key="i">
      <h4 v-if="chart.title">{{ chart.title }}</h4>
      <apexchart height="400" type="bar" :options="chart.options" :series="chart.series"></apexchart>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import NeedUpdateMixin from "../../NeedUpdateMixin";
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)


export default {
  name: "Slots",
  props: ['filter'],

  mixins: [NeedUpdateMixin],

  data() {
    return {
      charts: []
    }
  },

  created() {
    this.reload();
  },

  methods: {
    reload() {
      if (this.loading) {
        return;
      }

      this.$store.commit("loading")
      this.charts = []
      this.filter.channels.forEach(channel => {
        let ft = _.cloneDeep(this.filter)
        ft.channels = [ channel ]
        this.$store.dispatch('charts/slots', ft).then((data) => {
          let slots = ['F1', 'F2', 'F3']
          let series = slots.map(slot => {
            return { name: slot, data: [] }
          })

          let options = {
            chart: {
              type: 'bar',
              stacked: true,
              locales: this.getChartsLocales(),
              defaultLocale: "it",
            },
            //colors: ['#5A97AA', '#595959', '#D8D8D8', '#E91E63', '#173741'],
            colors: this.$store.state.colors,
            plotOptions: {
                bar: {
                    horizontal: false,
                },
            },
            xaxis: {
              type: 'datetime',
              categories: [],
            },
            dataLabels: {
              enabled: false
            },
            yaxis: {
              decimalsInFloat: 2
            }
          }

          data.values.forEach( (row) => {
            options.xaxis.categories.push(row[0])
            row.forEach( (v,i) => {
              if(i == 0)
                return

              series[i - 1].data.push(v)
            })
          })


          var chart = { options, series, title: data.title }

          this.charts.push(chart);
        })
      })
      this.$store.commit('stopLoading');
    }
  },

  watch: {
    filter() {
      _.debounce(this.reload, 100)();
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Apex/Slots.vue